"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingType = void 0;
var BookingType;
(function (BookingType) {
    BookingType["DirectBooking"] = "direct booking";
    BookingType["DirectContact"] = "direct contact";
    BookingType["Partnerchat"] = "partner chat";
})(BookingType || (exports.BookingType = BookingType = {}));
//# sourceMappingURL=BookingTypes.js.map